import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { AdminJobTypeInfoMap, AdminWaitingJob } from '@/models/dashboard.model';
import { getAdminWaitingJobs } from '@/services/dashboard.service';
import { toastErrorMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { Table, Panel, Badge } from 'rsuite';

const { Column, HeaderCell, Cell } = Table;

const AdminWaitingJobDataTable = () => {
  const [items, setItems] = useState<AdminWaitingJob[]>([]);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result: BaseResponseModel<AdminWaitingJob[]> = await getAdminWaitingJobs();
      if (result.success) {
        setItems(result.result);
      }
    } catch (err) {
      setItems([]);
      const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
      toastErrorMessage(`Error in fetching admin waiting jobs:${errorModel?.errorMessage}`);
    }
    finally {
      setLoading(false);
    }
  };  
  return (
    <Panel className="card" header="Waiting Jobs">
      <Table 
        height={300} 
        data={items} 
        loading={loading}
      >
        <Column flexGrow={1} minWidth={100}>
          <HeaderCell>Job Description </HeaderCell>
          <Cell>
            {(rowData: AdminWaitingJob) =>
                <a href={AdminJobTypeInfoMap[rowData.type].url} target="_blank" rel="noreferrer">
                  {AdminJobTypeInfoMap[rowData.type].label}
                </a>
            }
          </Cell>
        </Column>

        <Column width={130} align='center'>
          <HeaderCell>Count</HeaderCell>
          <Cell >
            {(rowData: AdminWaitingJob) => <Badge content={rowData.count}/>}
          </Cell>
        </Column>
      </Table>
    </Panel>
  );
};

export default AdminWaitingJobDataTable;
